var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityTalks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tab04_filled 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.573 44.2614C10.7494 44.7158 9.79802 45.156 8.77562 45.5678C6.75922 46.3488 4.33102 46.9878 1.91702 46.9878C1.16442 46.9878 0.482816 46.4624 0.241416 45.724C1.60933e-05 44.9714 0.269816 44.1478 0.866216 43.6792L0.894616 43.665C0.923016 43.6508 0.965616 43.6082 1.02242 43.5656C1.12182 43.4804 1.29222 43.3242 1.49102 43.1396C1.88862 42.7704 2.42822 42.2166 2.95362 41.5066C3.56422 40.7114 4.14642 39.76 4.52982 38.6808C1.77502 35.3438 0.156216 31.2542 0.156216 26.838C0.156216 15.7052 10.437 6.674 23.1318 6.674C35.8266 6.674 46.1074 15.7052 46.1074 26.838C46.1074 37.9708 35.8266 46.9878 23.1318 46.9878C18.9144 46.9878 14.9668 45.9938 11.573 44.2614ZM49.5722 25.0488C61.4718 25.8014 70.8438 34.5202 70.8438 45.156C70.8438 49.5864 69.225 53.676 66.4702 56.9988C66.8536 58.0638 67.4358 59.0152 68.0464 59.8246C68.5718 60.5346 69.1114 61.0884 69.509 61.4576C69.7078 61.6564 69.8782 61.7984 69.9776 61.8836C70.0344 61.9262 70.077 61.9546 70.1054 61.9688L70.1338 61.9972C70.7444 62.4658 71 63.2894 70.7728 64.042C70.5314 64.8088 69.8498 65.32 69.083 65.32C66.6832 65.32 64.255 64.681 62.2244 63.8858C61.2162 63.4882 60.279 63.0338 59.4412 62.5794C56.0474 64.326 52.0998 65.32 47.8824 65.32C37.3176 65.32 28.4142 59.072 25.7304 50.5378C38.695 49.3876 49.6432 39.7032 49.6432 26.838C49.629 26.2274 49.6148 25.631 49.5722 25.0488Z",
    fill: "#1471C7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityTalks);
export default __webpack_public_path__ + "static/media/activity-talks.ecb275f9d7b32dd4c01364803ae7cb48.svg";
export { ForwardRef as ReactComponent };